export default "__VITE_ASSET__5337f079__"